AuthRoute = require 'mixins/authenticated-route'

module.exports = App.IndexRoute = Em.Route.extend AuthRoute,
  beforeModelAuth: ->
    currentUser = @get('session.currentUser')

    switch
      when currentUser.get('isCourier')
        @transitionTo 'courier-apps'

      when currentUser.get('isStaffMember') and (currentUser.get('account.isAdmin') || currentUser.get('account.isRegionalAdmin'))
        @transitionTo 'dashboard'

      else
        @transitionTo 'orders'
